<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.principales?.txtLibre?.champsLibre[0]"
[label]="step3.gettextelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidTxtLibre()+'_SepAtt_champsLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.principales?.intLibre?.intituleLibre"
[label]="step3.getintitulelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidIntLibre()+'_SepAtt_intituleLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.principales?.intLibre?.intituleLibreLibelle"
[label]="step3.getintitulelibrelibelle"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUidIntLibre()+'_SepAtt_intituleLibreLibelle'">
</app-form-input>

<app-form-input
[label]="step3.getspan18"
[name]="getUid() + '_SepAtt_marcheUnique'"
[parentForm]="parentForm"
[disabled]="disabled"
[type]="'radio'"
[rule]="'pattern_29'"
[radios]="[
	{
		value: 'Oui',
		label: step3.getoui
	},
	{
		value: 'Non',
		label: step3.getnon
	}
]"
[value]="initial?.marcheUnique"
>
</app-form-input>
